window.is_ie = /MSIE|Trident/i.test(navigator.userAgent);
window.is_iphone = /iPhone|iPod/i.test(navigator.userAgent);
window.is_ios = /iPad|iPhone|iPod/.test(navigator.userAgent);
window.is_touch_device = 'ontouchstart' in document.documentElement;

document.addEventListener("DOMContentLoaded",function(){

  const params = new URLSearchParams(window.location.search);

  if($('.product .item .item-info .type_variant_picker input').val() == '39651811852366') {
    
    togglePriceDisplay();
    
    $('.product .item .item-info .type_quantity_selector').hide();
    
    $('.product .item .item-info .add-to-cart').on('click tap',(e) => {
      	calculateTotal();
      	ajaxCart.load();
    });

    $('body').on('change','#spiceaddonsappid input, #spiceaddonsappid select, #spiceaddonsappid .spice_select_variant_quantity',(e) => {
          calculateTotal();
    });
    $('body').on('click tap touchstart','#spiceaddonsappid .spice-spa-addon_plus_btn, #spiceaddonsappid .spice-spa-addon_minus_btn, #spiceaddonsappid .input_field_number button span',(e) => {
          calculateTotal();
    });
  }
  
  function calculateTotal() {
    let total = 0;
    $('#spiceaddonsappid .spice-spa-addon-checkbox-input:checked').each((index, element) => {
      let textPrice = $(element).closest('.spice-spa-addon-product-item').find('.spice-spa-addon-price-main').text();
      let quantity = $(element).closest('.spice-spa-addon-product-item').find('.spice-spa-addon-product-quantity .spice-spa-addon-input-field').val();
      price = parseInt(textPrice.replace(/\D/g,''));
      total += ( price * quantity );
    });

    $('.type_price .price').attr('data-total',total);
    $('.type_price .price').html(Colors.Currency.formatMoney(total, Colors.strings.money_format));
    $('.type_price .sezzle-shopify-info-button .sezzle-button-text span').text(Colors.Currency.formatMoney((total / 4), Colors.strings.money_format));

    togglePriceDisplay();
  }
  
  function togglePriceDisplay() {
    $('.product .item .item-info .type_quantity_selector .js-qty__num').val(0); // Force quantity to zero to exclude the main product add to cart
    let total = $('.type_price .price').attr('data-total');
    if (total != undefined && total > 0 ) {
      $('.type_price .price').show();
      $('.type_price .sezzle-shopify-info-button').show();
      $('.product .item .item-info .add-to-cart').removeAttr('disabled');
    } else {
      $('.type_price .price').hide();
      $('.type_price .sezzle-shopify-info-button').hide();
      $('.product .item .item-info .add-to-cart').attr('disabled','disabled');
    }
    $('.type_price .price.striped').hide();
  }

  $(document).on('touchstart click', '.side-menu [data-action=link-to-child-list][data-handle]', function(e){
      var $this = $(this),
          handle = $this.attr('data-handle'),
          $nav = $this.parents('.menu'),
          $list = $('.' + handle, $nav);
      e.preventDefault();
      if(is_touch_device && e.type == "click") return;
      if(!is_touch_device && e.type == "touchstart") return;
      if($list.length > 0){
        if($this.attr('aria-expanded') == "true") {
          $this.attr('aria-expanded', 'false');
        } else {
          $this.attr('aria-expanded', 'true');
        }
        $list.slideToggle(400, "easeOutQuad");
      }
  })
  if($('.side-menu').length > 0 && params.has("collection_title")) {
    let handle = params.get("collection_title"),
        $element = $(`.side-menu [data-action=link-to-child-list][data-handle='${handle}']`),
        $nav = $element.parents('.menu'),
        $list = $('.' + handle, $nav);
    
    $element.attr('aria-expanded', 'true');
    $list.slideToggle(400, "easeOutQuad");
  }
  
});